export const CALENDAR_PAGE = {
    HOUR_HEIGHT: 48,
    HOURS: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
    VIEWS: {
        day: {
            id: 'day',
            name: 'День',
        },
        days: {
            id: 'days',
            name: '3 дня',
        },
        week: {
            id: 'week',
            name: 'Неделя',
        },
        month: {
            id: 'month',
            name: 'Месяц',
        },
        year: {
            id: 'year',
            name: 'Год',
        },
    },
} as const;
